/**
 * Pure helpers for the "Deleted" tab UI (patch D6).
 *
 *   - `canRestoreItem` encodes the precondition that B4's item-restore
 *     route enforces (`assertParentLive`): the parent project must be
 *     live, and for SUB_PARTs the parent PART must be live. If either
 *     parent is also soft-deleted, the user must restore the parent
 *     first. Surfacing this client-side lets the UI disable the button
 *     with a helpful tooltip rather than letting the user click and
 *     receive a 400.
 *   - `restoreBlockedReason` returns the human-readable explanation
 *     when restoration is blocked, used as the tooltip / hint text.
 */
import type { DeletedItem } from './deleted-queries';

export function canRestoreItem(item: DeletedItem): boolean {
  if (item.parentProjectDeleted) return false;
  if (item.itemType === 'SUB_PART' && item.parentPartDeleted) return false;
  return true;
}

export function restoreBlockedReason(item: DeletedItem): string | null {
  if (item.parentProjectDeleted) {
    return 'Restore the parent project first.';
  }
  if (item.itemType === 'SUB_PART' && item.parentPartDeleted) {
    return `Restore the parent part (${item.parentPartName ?? '—'}) first.`;
  }
  return null;
}
